var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_113_2094)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_113_2094)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_113_2094)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_113_2094",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4483 0.551758H0.551758V31.4483H31.4483V0.551758Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_113_2094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0364 22.8719H21.5938L12.0194 9.17676H10.4619L20.0364 22.8719Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31.4483C24.5319 31.4483 31.4483 24.5319 31.4483 16C31.4483 7.46818 24.5319 0.551758 16 0.551758C7.46818 0.551758 0.551758 7.46818 0.551758 16C0.551758 24.5319 7.46818 31.4483 16 31.4483ZM16.9454 13.4496L21.9506 7.63153H23.9985L17.8548 14.773L24.4485 24.3688H19.1206L14.8928 18.216L9.59961 24.3688H7.55166L13.9836 16.8928L7.61992 7.63153H12.9477L16.9454 13.4496Z",
    fill: "#8C8C8C"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_113_2094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_113_2094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_113_2094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 30.8966,
    fill: "white",
    transform: "translate(0 0.551758)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.284eea8ee6a6059806a835c87c0d3bc5.svg";
export { ForwardRef as ReactComponent };